import React, { useEffect, useState } from "react";

const MESSAGES = [
  "Gathering the data…",
  "beep boop 1010111000…",
  "Searching the matrix…",
  "Pinging Google Trends…",
  "Reading the news so you don't have to…",
  "Scanning the open web…",
  "Following the signal…",
  "Crunching the numbers…",
  "Connecting the dots…",
  "Asking the internet nicely…",
  "Reticulating splines…",
  "Triangulating the trend…",
  "Sniffing out the story…",
  "Tuning the antenna…",
  "Decoding the chatter…",
  "Compiling the dossier…",
  "Counting the headlines…",
  "Consulting the oracle…",
  "Warming up the radar…",
  "Mapping the market…",
  "Gathering intel…",
  "Scanning frequencies…",
  "Brewing the report…",
  "Catching signals…",
  "Doing the math…",
  "Wrangling the bytes…",
  "Chasing data gremlins…",
  "Polishing the insights…",
  "Almost there…",
  "Locking on…",
];

export default function ReportLoading() {
  const [idx, setIdx] = useState(() => Math.floor(Math.random() * MESSAGES.length));

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((prev) => {
        let next = Math.floor(Math.random() * MESSAGES.length);
        if (next === prev) next = (next + 1) % MESSAGES.length;
        return next;
      });
    }, 1800);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid="report-loading"
      className="border border-neutral-900 bg-[#070707] ds-scanlines py-20 md:py-28 flex flex-col items-center justify-center text-center"
    >
      <div className="relative w-28 h-28 mb-10">
        <div className="absolute inset-0 rounded-full border border-[#FF5000]/30" />
        <div className="absolute inset-3 rounded-full border border-[#FF5000]/20" />
        <div className="absolute inset-6 rounded-full border border-[#FF5000]/15" />
        <div className="absolute left-1/2 top-1/2 w-1.5 h-1.5 -translate-x-1/2 -translate-y-1/2 bg-[#FF5000] ds-pulse" />
        <div
          className="absolute inset-0 ds-sweep rounded-full"
          style={{ background: "conic-gradient(from 0deg, rgba(255,80,0,0.45), rgba(255,80,0,0) 70deg)" }}
        />
      </div>

      <p
        key={idx}
        data-testid="report-loading-message"
        className="ds-fade-up text-white text-lg md:text-xl tracking-tight min-h-[1.6em]"
      >
        {MESSAGES[idx]}
      </p>
      <p className="mt-3 text-[11px] uppercase tracking-[0.3em] text-neutral-600 ds-mono">
        Pulling live data · this can take ~30–60s
      </p>
    </div>
  );
}
